var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// consts.ts
var consts_exports = {};
__export(consts_exports, {
  AUTH_HEADER_NAME: () => AUTH_HEADER_NAME,
  AuthMethod: () => AuthMethod,
  CORRELATION_ID_HEADER_NAME: () => CORRELATION_ID_HEADER_NAME,
  Chain: () => Chain,
  ContactType: () => ContactType,
  ErrorMessages: () => ErrorMessages,
  GuildPinAction: () => GuildPinAction,
  GuildSortType: () => GuildSortType,
  Logic: () => Logic,
  PARAMS_HEADER_NAME: () => PARAMS_HEADER_NAME,
  PRIVILEGED_USER_ID_HEADER: () => PRIVILEGED_USER_ID_HEADER,
  PlatformName: () => PlatformName,
  SDK_PROJECT_NAME_HEADER_NAME: () => SDK_PROJECT_NAME_HEADER_NAME,
  SDK_VERSION_HEADER_NAME: () => SDK_VERSION_HEADER_NAME,
  SERVICE_HEADER_NAME: () => SERVICE_HEADER_NAME,
  SIG_HEADER_NAME: () => SIG_HEADER_NAME,
  SocialLinks: () => SocialLinks,
  Visibility: () => Visibility
});
var SocialLinks = [
  "TWITTER",
  "LENS",
  "YOUTUBE",
  "SPOTIFY",
  "MIRROR",
  "MEDIUM",
  "SUBSTACK",
  "SNAPSHOT",
  "SOUND",
  "WEBSITE"
];
var Visibility = ["PUBLIC", "PRIVATE", "HIDDEN"];
var Chain = [
  "ETHEREUM",
  "BSC",
  "POLYGON",
  "AVALANCHE",
  "FANTOM",
  "ARBITRUM",
  "NOVA",
  "CELO",
  "HARMONY",
  "GOERLI",
  "OPTIMISM",
  "MOONRIVER",
  "MOONBEAM",
  "GNOSIS",
  "METIS",
  "CRONOS",
  "BOBA",
  "BOBA_AVAX",
  "PALM",
  "BASE_GOERLI",
  "BASE_MAINNET",
  "EXOSAMA",
  "EVMOS",
  "POLYGON_MUMBAI",
  "ZETACHAIN_ATHENS",
  "SCROLL_ALPHA",
  "SEPOLIA",
  "ZKSYNC_ERA",
  "ZORA"
];
var PlatformName = [
  "TELEGRAM",
  "DISCORD",
  "GITHUB",
  "TWITTER",
  "GOOGLE",
  "POAP",
  "CONTRACT_CALL",
  "TWITTER_V1"
];
var Logic = ["AND", "OR"];
var ErrorMessages = {
  INVALID_GUILDPLATFORM_INDEX: "Invalid guildPlatformIndex. Make sure all guildPlatformIndex values reference an existing item from guildPlatforms",
  EMPTY_OBJECT: "At least one of the fields must be defined",
  INVALID_ADDRESS: "Invalid address",
  REQUIRED_PLATFORM_GUILD_DATA: "platformGuildData is required",
  ADMIN_UPDATE_IS_OWNER_FALSE: "It is only possible to update an admin to be an owner. But doing so the previous owner will lose ownership"
};
var GuildPinAction = ["JOINED_GUILD", "IS_OWNER", "IS_ADMIN"];
var ContactType = ["EMAIL", "TELEGRAM"];
var AuthMethod = {
  EOA: "1",
  KeyPair: "2",
  EIP1271: "3"
};
var PARAMS_HEADER_NAME = "x-guild-params";
var SIG_HEADER_NAME = "x-guild-sig";
var AUTH_HEADER_NAME = "x-guild-auth";
var SERVICE_HEADER_NAME = "x-guild-service";
var PRIVILEGED_USER_ID_HEADER = "x-guild-privileged-user-id";
var CORRELATION_ID_HEADER_NAME = "x-correlation-id";
var SDK_VERSION_HEADER_NAME = "x-guild-sdk-version";
var SDK_PROJECT_NAME_HEADER_NAME = "x-guild-sdk-project-name";
var GuildSortType = ["NEWEST", "VERIFIED", "FEATURED"];

// schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  AuthenticationParamsSchema: () => AuthenticationParamsSchema,
  AuthenticationSchema: () => AuthenticationSchema,
  GuildAdminCreationPayloadSchema: () => GuildAdminCreationPayloadSchema,
  GuildAdminUpdatePayloadSchema: () => GuildAdminUpdatePayloadSchema,
  GuildContactCreationPayloadSchema: () => GuildContactCreationPayloadSchema,
  GuildContactUpdatePayloadSchema: () => GuildContactUpdatePayloadSchema,
  GuildCreationPayloadSchema: () => GuildCreationPayloadSchema,
  GuildGetManyQueryParamsSchema: () => GuildGetManyQueryParamsSchema,
  GuildRewardCreationSchema: () => GuildRewardCreationSchema,
  GuildRewardUpdateSchema: () => GuildRewardUpdateSchema,
  GuildSearchQueryParamsSchema: () => GuildSearchQueryParamsSchema,
  GuildUpdatePayloadSchema: () => GuildUpdatePayloadSchema,
  IssueGuildPinPayloadSchema: () => IssueGuildPinPayloadSchema,
  JoinActionPayloadSchema: () => JoinActionPayloadSchema,
  LinkParamsSchema: () => LinkParamsSchema2,
  PlatformUserCreationSchema: () => PlatformUserCreationSchema,
  RequirementCreationPayloadSchema: () => RequirementCreationPayloadSchema,
  RequirementUpdatePayloadSchema: () => RequirementUpdatePayloadSchema,
  RoleCreationForGuildCreationPayloadSchema: () => RoleCreationForGuildCreationPayloadSchema,
  RoleCreationPayloadSchema: () => RoleCreationPayloadSchema,
  RolePlatformClaimPayloadSchema: () => RolePlatformClaimPayloadSchema,
  RoleRewardCreationForGuildCreationPayloadSchema: () => RoleRewardCreationForGuildCreationPayloadSchema,
  RoleRewardCreationPayloadSchema: () => RoleRewardCreationPayloadSchema,
  RoleRewardUpdatePayloadSchema: () => RoleRewardUpdatePayloadSchema,
  RoleUpdatePayloadSchema: () => RoleUpdatePayloadSchema,
  StatusUpdateActionPayloadSchema: () => StatusUpdateActionPayloadSchema,
  UserAddressCreationPayloadSchema: () => UserAddressCreationPayloadSchema,
  UserAddressUpdatePayloadSchema: () => UserAddressUpdatePayloadSchema,
  VerifyKeyPayloadSchema: () => VerifyKeyPayloadSchema
});

// schemas/actions.ts
import { z } from "zod";
var JoinActionPayloadSchema = z.object({
  guildId: z.number().int().positive()
});
var StatusUpdateActionPayloadSchema = z.object({
  roleIds: z.array(z.number().int().positive()),
  recheckAccess: z.boolean().optional(),
  updateMemberships: z.boolean().optional(),
  manageRewards: z.boolean().optional(),
  forceRewardActions: z.boolean().optional(),
  onlyForThisPlatform: z.boolean().optional()
});

// schemas/auth.ts
import { z as z3 } from "zod";

// schemas/common.ts
import { z as z2 } from "zod";
var VisibilitySchema = z2.enum(Visibility);
var ChainSchema = z2.enum(Chain);
var PlatformNameSchema = z2.enum(PlatformName);
var EvmAddressSchema = z2.string().regex(/^0x[0-9a-f]{40}$/i, ErrorMessages.INVALID_ADDRESS);
var LogicSchema = z2.enum(Logic);
var GuildPinActionSchema = z2.enum(GuildPinAction);
var ContactTypeSchema = z2.enum(ContactType);
var GuildSortTypeSchema = z2.enum(GuildSortType);

// schemas/auth.ts
var AuthenticationParamsSchema = z3.object({
  addr: EvmAddressSchema.toLowerCase(),
  nonce: z3.string(),
  msg: z3.string(),
  ts: z3.string(),
  hash: z3.string().optional()
}).and(
  z3.union([
    z3.object({
      chainId: z3.string(),
      method: z3.literal(AuthMethod.EIP1271)
    }),
    z3.object({
      method: z3.literal(AuthMethod.EOA)
    }),
    z3.object({
      method: z3.literal(AuthMethod.KeyPair)
    })
  ])
);
var AuthenticationSchema = z3.object({
  params: AuthenticationParamsSchema,
  sig: z3.string()
});

// schemas/contact.ts
import { z as z4 } from "zod";
var options = {
  EMAIL: z4.object({ type: z4.literal("EMAIL"), contact: z4.string().email() }),
  TELEGRAM: z4.object({ type: z4.literal("TELEGRAM"), contact: z4.string() })
  // So we don't forget to update here in case ContactType changes
};
var GuildContactCreationPayloadSchema = z4.discriminatedUnion("type", [
  options.EMAIL,
  options.TELEGRAM
]);
var GuildContactUpdatePayloadSchema = GuildContactCreationPayloadSchema;

// schemas/guild.ts
import { z as z9 } from "zod";

// utils.ts
var ZERO_CODE = 48;
var NINE_CODE = ZERO_CODE + 9;
var isCharNumeric = (char) => char.charCodeAt(0) >= ZERO_CODE && char.charCodeAt(0) <= NINE_CODE;
var isNumeric = (str) => [...str].every((char) => isCharNumeric(char));
var nonEmptyRefine = (message = ErrorMessages.EMPTY_OBJECT) => [
  (someObject) => Object.keys(someObject).length > 0,
  { message }
];

// schemas/guildReward.ts
import { z as z5 } from "zod";
var GuildRewardCreationSchema = z5.object({
  platformName: PlatformNameSchema,
  platformGuildId: z5.string().transform(
    (value) => value.includes("/") ? encodeURIComponent(value) : value
  ),
  platformGuildData: z5.any().optional(),
  roleIds: z5.array(z5.number().int().positive()).optional()
});
var GuildRewardUpdateSchema = GuildRewardCreationSchema.pick({
  platformGuildData: true
}).refine(...nonEmptyRefine(ErrorMessages.REQUIRED_PLATFORM_GUILD_DATA));

// schemas/role.ts
import { z as z8 } from "zod";

// schemas/requirement.ts
import { z as z6 } from "zod";
var BaseRequirementSchema = z6.object({
  data: z6.any(),
  type: z6.string().max(50),
  // roleId: z.number().int().positive(), <- Comes from path param
  name: z6.string().max(150).optional(),
  symbol: z6.string().max(100).optional(),
  isNegated: z6.boolean().optional(),
  visibility: VisibilitySchema.optional()
});
var AddressAndChainSchema = z6.object({
  chain: ChainSchema,
  address: EvmAddressSchema
});
var RequirementCreationPayloadSchema = z6.intersection(
  BaseRequirementSchema,
  // These two are optional "together"
  z6.union([
    AddressAndChainSchema,
    z6.object({ chain: z6.undefined(), address: z6.undefined() })
  ])
);
var RequirementUpdatePayloadSchema = z6.intersection(
  BaseRequirementSchema.omit({
    // roleId: true,
    type: true
  }).partial(),
  AddressAndChainSchema.partial()
).refine(...nonEmptyRefine());

// schemas/roleReward.ts
import { z as z7 } from "zod";
var BaseRoleRewardSchema = z7.object({
  platformRoleId: z7.string(),
  visibility: VisibilitySchema,
  platformRoleData: z7.any().optional()
});
var GuildPlatformResolvableSchema = z7.union([
  z7.object({
    guildPlatform: GuildRewardCreationSchema.omit({ roleIds: true }),
    guildPlatformId: z7.undefined()
  }),
  z7.object({
    guildPlatformId: z7.number().int().positive(),
    guildPlatform: z7.undefined()
  })
]);
var GuildPlatformIndexableSchema = z7.object({
  guildPlatformIndex: z7.number().int().positive(),
  guildPlatformId: z7.undefined(),
  guildPlatform: z7.undefined()
});
var RoleRewardCreationPayloadSchema = z7.intersection(
  BaseRoleRewardSchema.partial(),
  GuildPlatformResolvableSchema
);
var RoleRewardCreationForGuildCreationPayloadSchema = z7.intersection(
  BaseRoleRewardSchema.partial(),
  GuildPlatformIndexableSchema
);
var RoleRewardUpdatePayloadSchema = BaseRoleRewardSchema.partial().refine(...nonEmptyRefine());
var RolePlatformClaimPayloadSchema = z7.object({
  args: z7.array(z7.string())
});

// schemas/role.ts
var RoleBaseSchema = z8.object({
  name: z8.string().max(50),
  description: z8.string().max(1e3).optional(),
  imageUrl: z8.string().max(500).optional(),
  // TODO: Check for .url() OR .regex(/\/guildLogos\/[0-285]\.svg/, "Invalid imageUrl")
  logic: LogicSchema.optional(),
  visibility: VisibilitySchema.optional(),
  anyOfNum: z8.number().int().positive().optional()
});
var RoleCreationPayloadSchema = z8.intersection(
  RoleBaseSchema,
  z8.object({
    requirements: z8.array(RequirementCreationPayloadSchema).min(1),
    rolePlatforms: z8.array(RoleRewardCreationPayloadSchema).optional()
  })
);
var RoleCreationForGuildCreationPayloadSchema = z8.intersection(
  RoleBaseSchema,
  z8.object({
    requirements: z8.array(RequirementCreationPayloadSchema).min(1),
    rolePlatforms: z8.array(RoleRewardCreationForGuildCreationPayloadSchema).optional()
  })
);
var RoleUpdatePayloadSchema = z8.intersection(
  RoleBaseSchema.partial(),
  z8.object({ position: z8.number().int().positive().optional() })
).refine(...nonEmptyRefine());

// schemas/guild.ts
var ThemeSchema = z9.object({
  mode: z9.enum(["DARK", "LIGHT"]),
  color: z9.string().max(10),
  backgroundImage: z9.string().max(100),
  backgroundCss: z9.string().max(10)
});
var BaseGuildSchema = z9.object({
  name: z9.string().max(50),
  urlName: z9.string().max(50),
  description: z9.string().max(1500).optional(),
  imageUrl: z9.string().max(500).optional(),
  // z
  //   .union([
  //     z.string().regex(/\/guildLogos\/[0-285]\.svg/, "Invalid imageUrl"),
  //     z.string().max(500).url(),
  //   ])
  //   .optional(),
  showMembers: z9.boolean().optional(),
  hideFromExplorer: z9.boolean().optional(),
  socialLinks: z9.enum(SocialLinks).optional(),
  onboardingComplete: z9.boolean().optional(),
  theme: ThemeSchema.partial().optional()
});
var GuildCreationPayloadSchema = BaseGuildSchema.and(
  z9.object({
    guildPlatforms: z9.array(GuildRewardCreationSchema).optional(),
    roles: z9.array(RoleCreationForGuildCreationPayloadSchema).min(1)
  })
).refine(
  (ctx) => {
    const hasGuildPlatforms = Array.isArray(ctx.guildPlatforms) && ctx.guildPlatforms.length > 0;
    return ctx.roles.every(
      (role) => !role.rolePlatforms || role.rolePlatforms.every(
        (rolePlatform) => !rolePlatform?.guildPlatformIndex || hasGuildPlatforms && rolePlatform?.guildPlatformIndex < (ctx.guildPlatforms?.length ?? 0)
      )
    );
  },
  { message: ErrorMessages.INVALID_GUILDPLATFORM_INDEX }
);
var GuildUpdatePayloadSchema = BaseGuildSchema.partial().refine(
  ...nonEmptyRefine()
);
var GuildSearchQueryParamsSchema = z9.object({
  order: GuildSortTypeSchema.optional(),
  search: z9.string().optional(),
  limit: z9.number().int().positive(),
  offset: z9.number().int().nonnegative()
});
var GuildGetManyQueryParamsSchema = z9.object({
  guildIds: z9.string().refine(
    (guildIdsParam) => {
      const splits = guildIdsParam.split(",");
      const allSplitsAreValid = splits.every((split) => isNumeric(split));
      return allSplitsAreValid;
    },
    { message: "Invalid guildIds, please provide comma-separated numbers" }
  )
});

// schemas/guildAdmin.ts
import { z as z10 } from "zod";
var GuildAdminCreationPayloadSchema = z10.object({
  address: EvmAddressSchema,
  isOwner: z10.boolean().optional()
});
var GuildAdminUpdatePayloadSchema = z10.object({
  isOwner: z10.boolean().refine((value) => value === true, {
    message: ErrorMessages.ADMIN_UPDATE_IS_OWNER_FALSE
  })
});

// schemas/guildPin.ts
import { z as z11 } from "zod";
var IssueGuildPinPayloadSchema = z11.object({
  userAddress: EvmAddressSchema,
  guildAction: GuildPinActionSchema,
  chainId: z11.number().int().positive(),
  contractAddress: EvmAddressSchema
});

// schemas/platformUser.ts
import { z as z12 } from "zod";
var PlatformUserCreationSchema = z12.object({
  platformName: PlatformNameSchema,
  authData: z12.any(),
  // TODO: This could be typed easily, as the diffferent OAuth payloads mostly look the same
  disconnectFromExistingUser: z12.boolean().optional()
});

// schemas/userAddress.ts
import { z as z13 } from "zod";
var LinkParamsSchema = z13.union([
  z13.object({
    signature: z13.string(),
    nonce: z13.string(),
    timestamp: z13.number().int().positive()
  }),
  z13.object({
    signature: z13.undefined(),
    nonce: z13.undefined(),
    timestamp: z13.undefined()
  })
]);
var UserAddressCreationPayloadSchema = z13.object({
  address: EvmAddressSchema.toLowerCase(),
  isPrimary: z13.boolean().default(false),
  isDelegated: z13.boolean().default(false)
}).and(LinkParamsSchema);
var UserAddressUpdatePayloadSchema = z13.object({
  isPrimary: z13.boolean()
});

// schemas/verify.ts
import { z as z14 } from "zod";
var LinkParamsSchema2 = z14.union([
  z14.object({
    userId: z14.number().int().positive(),
    signature: z14.string(),
    nonce: z14.string()
  }),
  z14.object({ isDelegated: z14.boolean() }),
  z14.object({
    userId: z14.undefined(),
    signature: z14.undefined(),
    nonce: z14.undefined(),
    isDelegated: z14.undefined()
  })
]);
var VerifyKeyPayloadSchema = z14.object({
  pubKey: z14.string(),
  verificationParams: z14.object({ reCaptcha: z14.string() }).optional()
}).and(LinkParamsSchema2);

// types.ts
var types_exports = {};
export {
  consts_exports as consts,
  schemas_exports as schemas,
  types_exports as types
};
